import { render, staticRenderFns } from "./LayoutContentVerticalNav.vue?vue&type=template&id=44169208&scoped=true&"
import script from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js&"
export * from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentVerticalNav.vue?vue&type=style&index=0&id=44169208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44169208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
